import React from "react";
import Helmet from "react-helmet";

const Head = () => (
	<Helmet>
		<meta charset="utf-8" />
		<meta http-equiv="x-ua-compatible" content="ie=edge" />
		<meta name="viewport" content="width=device-width, initial-scale=1" />
		<title>Andy Lincoln - Web Developer</title>
		<link
			href="https://fonts.googleapis.com/css?family=Source+Code+Pro|Source+Sans+Pro"
			rel="stylesheet"
		/>
		<meta name="apple-mobile-web-app-title" content="Andy Lincoln" />
		<meta name="application-name" content="Andy Lincoln" />
		<meta name="theme-color" content="#121212" />
	</Helmet>
);

export default Head;



// WEBPACK FOOTER //
// ./src/components/Head.js